import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";
import CircleAnglesDiagram from "../../components/diagrams/CircleAnglesDiagram";
import SameArcInscribedAnglesDiagram from "../../components/diagrams/SameArcInscribedAnglesDiagram";

function CenteredDiagram({ children }) {
  return (
    <div style={{ display: "flex", justifyContent: "center", margin: "16px 0" }}>
      {children}
    </div>
  );
}

export default function CircleAnglesPreparationTheory() {
  const intro = (
    <div className="space-y-3">
      <p>
        Kąt środkowy ma wierzchołek w środku okręgu, a kąt wpisany — na okręgu.
        Jeżeli oba są oparte na tym samym łuku, kąt środkowy jest dwa razy większy.
      </p>
      <CenteredDiagram>
        <CircleAnglesDiagram
          centralDeg={100}
          centralLabel="100^{\circ}"
          inscribedLabel="50^{\circ}"
          centralTone="given"
          inscribedTone="unknown"
        />
      </CenteredDiagram>
      <BlockMath math={String.raw`\alpha_{\text{śr}}=2\alpha_w,\qquad \alpha_w=\frac12\alpha_{\text{śr}}`} />
      <p>
        Kąty wpisane oparte na tym samym łuku mają tę samą miarę. Na rysunku
        zawsze najpierw wskazujemy łuk, na którym opiera się pytany kąt.
      </p>
    </div>
  );

  const examples = [
    {
      label: "Przykład 1",
      summary: "Od kąta środkowego do wpisanego",
      description: (
        <>
          Kąt środkowy oparty na łuku <InlineMath math="AB" /> ma miarę{" "}
          <InlineMath math="120^{\circ}" />.
        </>
      ),
      content: (
        <>
          <CenteredDiagram>
            <CircleAnglesDiagram
              centralDeg={120}
              centralLabel="120^{\circ}"
              inscribedLabel="60^{\circ}"
              centralTone="given"
              inscribedTone="unknown"
            />
          </CenteredDiagram>
          <BlockMath math={String.raw`\alpha_w=\frac12\cdot120^{\circ}=60^{\circ}`} />
        </>
      ),
    },
    {
      label: "Przykład 2",
      summary: "Od kąta wpisanego do środkowego",
      description: (
        <>
          Kąt wpisany oparty na łuku <InlineMath math="AB" /> ma miarę{" "}
          <InlineMath math="36^{\circ}" />.
        </>
      ),
      content: (
        <>
          <CenteredDiagram>
            <CircleAnglesDiagram
              centralDeg={72}
              centralLabel="72^{\circ}"
              inscribedLabel="36^{\circ}"
              centralTone="given"
              inscribedTone="unknown"
            />
          </CenteredDiagram>
          <BlockMath math={String.raw`\alpha_{\text{śr}}=2\cdot36^{\circ}=72^{\circ}`} />
        </>
      ),
    },
    {
      label: "Przykład 3",
      summary: "Dwa kąty wpisane na tym samym łuku",
      description: (
        <>
          Jeden z kątów wpisanych opartych na łuku <InlineMath math="AB" /> ma miarę{" "}
          <InlineMath math="54^{\circ}" />.
        </>
      ),
      content: (
        <>
          <CenteredDiagram>
            <SameArcInscribedAnglesDiagram angleLabel="54^{\circ}" />
          </CenteredDiagram>
          <BlockMath math={String.raw`\angle APB=\angle AQB=54^{\circ}`} />
        </>
      ),
    },
  ];

  return <TheoryExamplesRunner intro={intro} examples={examples} />;
}
